<!------------ START TEMPLATE ------------>
<template>
  <div id="data-list-list-view" class="data-list-container">
    <add-new-data-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="addNewDataSidebar = false"
      :form="formSideBar"
      :title="titleSideBar"
      :dados="dadosSideBar"
      @criacaoConcluida="atualizarDados"
    />
    <vs-table
      noDataText="Nenhuma Classe Encontrada"
      class="tablePrincipal"
      ref="table"
      v-model="selected"
      :max-items="itemsPerPage"
      :data="itens"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div class="flex flex-wrap-reverse items-center">
          <!------------ START ADD NOVO USUÁRIO ------------>
          <div
            class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="openSideBar({})"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary"
              >Adicionar nova Classe</span
            >
          </div>
        </div>
        <!------------ END ADD NOVO USUÁRIO ------------>

        <!------------ START ITENS POR PÁGINA ------------>
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ paginaAtual * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                count - paginaAtual * itemsPerPage > 0
                  ? paginaAtual * itemsPerPage
                  : count
              }}
              de {{ count }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>50</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <!------------ END ITENS POR PÁGINA ------------>

      <!------------ START TITULO DA TABELA ------------>

      <template slot="thead">
        <vs-th sort-key="idclasse">ID</vs-th>
        <vs-th class="w-1/6" sort-key="Nome">Nome</vs-th>
        <vs-th sort-key="createdAt">Data</vs-th>
        <vs-th>Status</vs-th>
        <vs-th>Editar</vs-th>
      </template>
      <!------------ END TITULO DA TABELA ------------>

      <!------------ START TABELA ------------>
      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-category">{{ tr.idClasse }}</p>
            </vs-td>

            <vs-td>
              <vs-list-item :title="tr.nome"></vs-list-item>
            </vs-td>

            <vs-td>
              <p class="product-category">
                {{ new Date(tr.createdAt).toLocaleDateString() }}
              </p>
            </vs-td>

            <vs-td>
              <vs-chip
                :color="getStatusColor(tr.deletedAt)"
                class="product-order-status"
                >{{ getStatusString(tr.deletedAt) }}</vs-chip
              >
            </vs-td>
            <vs-td>
              <div class="vx-row">
                <div
                  class="vx-col"
                  v-if="$can($actionsDefault.Escrita, subjectPermission)"
                >
                  <vs-button
                    v-tooltip="'Editar Classe'"
                    radius
                    color="success"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="d-inline"
                    @click="openSideBar(tr)"
                  ></vs-button>
                </div>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <vs-pagination :total="totalPages" :max="7" v-model="paginaAtual" />

    <!------------ END TABELA ------------>
  </div>
</template>
<!------------ START TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import AddNewDataSidebar from './../Includes/SideBar';
import service from '../../services';
import jwt from 'jsonwebtoken';

export default {
  components: {
    AddNewDataSidebar,
  },
  props: ['subjectPermission'],
  data() {
    return {
      isAdmin: false,
      dadosSideBar: {},
      controllerGeral: 'classe',
      formSideBar: 'Classe',
      entidade: 'Classe',
      popupActive: false,
      modalCodigoAcesso: false,
      modalSelecionado: [],
      userAlteracao: null,
      selected: [],
      itens: [],
      colunas: {},
      itemsPerPage: 10,
      isMounted: false,
      addNewDataSidebar: false,
      senha: null,
      id_usuario: null,
      pages: 1,
      count: 0,
      paginaAtual: 1,
      searchQuery: '',
      totalPages: null,
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
  },
  watch: {
    paginaAtual() {
      console.log(this.paginaAtual);
      this.buscaDados(this.paginaAtual);
    },
    itemsPerPage() {
      this.paginaAtual = 1;
      console.log(this.itemsPerPage);
      this.buscaDados(null, this.itemsPerPage);
    },
  },
  methods: {
    verificaAdmin() {
      const token = localStorage.getItem('user-token');
      if (token) {
        const decoded = jwt.decode(token);
        if (decoded.nomePerfil === 'Super User') this.isAdmin = true;
      }
    },
    async atualizarDados() {
      try {
        await this.buscaDados();
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Erro ao buscar dados após criação/atualização',
          color: 'danger',
        });
      }
    },
    async buscaDados(paginaAtual = null, itemsPerPage = null) {
      if (paginaAtual != null) this.paginaAtual = paginaAtual;
      if (itemsPerPage != null) this.itemsPerPage = itemsPerPage;
      this.$vs.loading();

      try {
        const classe = await service.getAll(
          `${this.controllerGeral}`,
          {},
          `obterClasses/${this.paginaAtual}/${this.itemsPerPage}/false`,
        );
        this.itens = classe.data.classes;
        this.totalPages = classe.data.pagination.totalPages;
        this.count = classe.data.pagination.totalCount;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: 'Nenhum Registro Encontrado',
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    cleanString(str) {
      // Substituir caracteres acentuados usando regex
      str = str.replace(/[áàâãä]/g, 'a');
      str = str.replace(/[éèêë]/g, 'e');
      str = str.replace(/[íìîï]/g, 'i');
      str = str.replace(/[óòôõö]/g, 'o');
      str = str.replace(/[úùûü]/g, 'u');
      str = str.replace(/[ç]/g, 'c');

      // Converter para maiúsculas
      return str.toUpperCase();
    },
    openSideBar(dados) {
      dados.nome == null
        ? (this.titleSideBar = `Adicionar ${this.entidade} `)
        : (this.titleSideBar = `Editar dados do  ${this.entidade}`);
      this.dadosSideBar = dados;
      this.addNewDataSidebar = true;
    },
    openModal(cod) {
      this.modalSelecionado = [];
      this.popupActive = true;
      let item = { ...this.itens.find((x) => x.idUsuario == cod) };
      item = this.formataProgramaAfiliados(item);
      Object.keys(item).forEach((element) => {
        if (
          element != 'createdAt' &&
          element != 'updatedAt' &&
          element != 'deletedAt' &&
          element.indexOf('id') != 0
        )
          this.modalSelecionado.push({
            coluna: element,
            [element]: item[element],
          });
      });
    },
    getStatusColor(data) {
      if (data == null) return 'success';
      return 'danger';
    },
    getStatusString(data) {
      if (data == null) return 'Ativo';
      return 'Inativo';
    },
    openModalCodigoAcesso(cod) {
      this.codigoAcesso = this.itens.find(
        (x) => x.idUsuario == cod,
      ).codigoAcesso;
      this.modalCodigoAcesso = true;
    },
  },
  created() {
    this.getDecoded();
  },
  mounted() {
    this.isMounted = true;
    this.verificaAdmin();
    this.buscaDados();
  },
};
</script>
<!------------ END SCRIPT ------------>

<!------------ START STYLE ------------>
<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<!------------ END STYLE ------------>
